export const HEIGHTS: Record<string, number> = {
  H1: 38,
  H2: 34,
  H3: 30,
  P: 28,
};
export const INITIAL_TOP_OFFSET = 8;
export const INITIAL_LEFT_OFFSET = 8;
export const MENU_BUTTON_HEIGHT = 16;
export const HIDE_BLOCK_MENU_CLASSNAME = 'hide-block-menu-button';
